import * as React from 'react'
import { cn } from '@/lib/utils'

// ── Class-string helpers for native inputs ────────────────────────────────────

export const inputClass = (hasError = false) =>
  cn(
    'w-full px-3 py-[0.65rem] border rounded-md text-[0.9rem] outline-none bg-surface text-text box-border',
    'transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-accent focus-visible:border-accent',
    hasError ? 'border-danger-border' : 'border-border-input',
  )

export const selectClass = (hasError = false) =>
  cn(inputClass(hasError), 'cursor-pointer')

export const textareaClass = (hasError = false) =>
  cn(inputClass(hasError), 'resize-y min-h-[100px] font-[inherit]')

// ── FormField ─────────────────────────────────────────────────────────────────

interface FormFieldProps {
  label: string
  htmlFor?: string
  required?: boolean
  error?: string
  hint?: string
  children: React.ReactNode
  style?: React.CSSProperties
  className?: string
}

export function FormField({
  label,
  htmlFor,
  required,
  error,
  hint,
  children,
  style,
  className,
}: FormFieldProps) {
  return (
    <div style={style} className={cn('mb-4', className)}>
      <label
        htmlFor={htmlFor}
        className="block text-sm font-semibold text-text-heading mb-[0.35rem]"
      >
        {label}
        {required && (
          <span aria-hidden="true" className="text-danger-text ml-[2px]">*</span>
        )}
      </label>
      {children}
      {error && (
        <span role="alert" className="text-danger-text text-[0.8rem] mt-1 block">
          {error}
        </span>
      )}
      {hint && !error && (
        <span className="text-xs text-text-3 block mt-[0.2rem]">{hint}</span>
      )}
    </div>
  )
}
